import React from "react";
import "./PNUDSectionTitle.css";

export default function PNUDSectionTitle({ text }) {
  return (
    <div className="pnud-section-title-container">
      <h2 className="pnud-section-title">{text}</h2>
    </div>
  );
}
